module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/12-75479c192ecf53174454d1938fb5a1f9.jpg";